import { render } from "./DTEncuestas.vue?vue&type=template&id=036a7990"
import script from "./DTEncuestas.vue?vue&type=script&lang=js"
export * from "./DTEncuestas.vue?vue&type=script&lang=js"

import "./DTEncuestas.vue?vue&type=style&index=0&id=036a7990&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__